export const CustomTimePicker = {
  center: {
    textAlign: 'center',
    justifyContent: 'center'
  },
  textFieldStyle: {
    marginTop: -16,
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center'
  },
  inputStyle: {
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center'
  },
  hintStyle: {
    width: '100%',
    color: '#ccc',
    textAlign: 'center',
    justifyContent: 'center'
  },
  dropdown: {
    width: '100%',
    maxWidth: 400
  },
  fromTo: {
    fontWeight: 'bold',
    marginTop: 30,
    marginBottom: 0
  },
  dialogButton: {
    margin: 5
  }
};



// WEBPACK FOOTER //
// ./src/app/components/elements/elements.css.js